import { Node } from "reactflow";
import { createContainer } from "unstated-next";
import { CheckedUIListType } from "./state/useSaasAndThinkAppState";
/**
 * HomeUsePlugin child 容器
 *
 * - 只要是 HomeUsePlugin 组件子节点都可以通过 `useHomeUsePlugin` 得到内部数据和逻辑，可避免深度传递
 *
 * @returns
 */
type ParamsType = {
  nodeDataRef: React.MutableRefObject<{
    [key: string]: any;
  }>;
  newEdgeDataRef: React.MutableRefObject<{
    [key: string]: any;
  }>;
  newLineDataRef: React.MutableRefObject<{
    [key: string]: any;
  }>;
  onNodeContentChange: (nodesData: any[]) => void;
  onEdgeContentChange: (edgesData: any[]) => void;
  getStartEndNodesContentArr: (prevNodes: any[], currNodes?: any[]) => any[];
  getSimpleNodeData: (node: any) => any;
  getSaveDataV3: (templateObj: object, edges: any, variableList: any, params: object) => any;
  setNodes: (node: any) => any;
  setEdges: (edge: any) => any;
  getHomeNodes: () => any;
  getHomeEdges: () => any;
  handleCustomToGroup: (preNodeId: string, newNodeArr: Array<any>) => any;
  handleDeleteSingleNodeByPreviewBtn: (nodeId: string) => any;
  getAndSetQueryV3: (id: string, text: string) => Promise<{ lineType: string; identifier: any } | undefined>;
  clickRunAllBtn: (sourceNodeArr: any[], isFromPreview: boolean) => Promise<void>;
  handleSave: (data: any) => Promise<any>;
  handleHiddenNode: (arr: any[]) => any[];
  emptyPreviewApp: (byUnpublish: boolean) => void;
  autoSelectTemplate: (byUnpublish: boolean, autoAddInput: boolean) => void;
  addToPreviewList: (info?: PreviewApp.FormatChooseAppType | null) => void;
  resetStartNodeIds: (isStatic: boolean) => void;
  getUIListParam: (list: CheckedUIListType[]) => any[];
  handleGroupToCustom: (preNodeId: string, newNode: any) => any;
  handleInputField: (currentNode: any, type?: string, cotDescription?: string) => void;
  addIndividual: (node: any, previewUI?: string, isCotAddToPreview?: boolean, showNewPreview?: any) => void;
  clickGroupToPreview: (node: any, previewUI?: string, isCotAddToPreview?: boolean, showNewPreview?: any) => void;
  initNewProjectV2: any;
  clickAddNodeBtn: (e: any, data?: {}) => { nodeId: string };
  autoAddInputNodeByBluePrint: (param: {
    edgeNode: Node;
    nodes: Array<Node<any>>;
    inputs: Array<{ description: string; name: string; type: string }>;
  }) => void;
  addThink: (word: string) => void;
};
function useContainer(props?: ParamsType) {
  return props as ParamsType;
}

export const HomeChildContainer = createContainer(useContainer);
export const { Provider: HomeChildProvider, useContainer: useHomeChildContainer } = HomeChildContainer;
